// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"text-module--tooltip--1ENTK"};